// @ts-nocheck
import { httpClient } from '../../../core/network';

class UserPreferencesService {
  static fetchRegions() {
    const apiUrl = '/userpreferences/regions';
    return httpClient.get(apiUrl);
  }
}

export default UserPreferencesService;
